import { useMemo } from 'react'
import { z, type ZodSchema } from '@sevenrooms/form'

export type SearchForm = ZodSchema<typeof useSearchFormSchema>
export const useSearchFormSchema = () =>
  useMemo(
    () =>
      z.object({
        partySize: z.number(),
        startTime: z.string(),
        duration: z.number().optional(),
        haloTimeIntervalMinutes: z.number(),
        startDate: z.date(),
      }),
    []
  )
